import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";
import * as requestFromServer from "./ticketManagementApis";


// ticket management -> get tickets api
export const getTicketsAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.getTickets(dataToBeSent);
  if (response) {
    dispatch(Actions.createAction(Actions.GET_TICKET_MANAGEMENT_LIST, {tickets:response}))
    toastService.success(response?.message);
    setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null;
    }
};

// ticket management -> get ticket by id api
export const getTicketManagementByIdAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.getTicketManagementById(dataToBeSent);
  if (response) {
    setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null;
    }
};

// ticket management -> update ticket status api
export const updateTicketStatusAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.updateTicketStatus(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null;
    }
};

// ticket management -> start support ticket chat conversation api
export const startSupportTicketChatConversationAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.startSupportTicketChatConversation(dataToBeSent);
  if (response) {
    setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null;
    }
};

// chat conversation -> get chat conversation by id api
export const getTicketManagementChatByIdAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.getTicketManagementChatById(dataToBeSent);
  if (response) {
    setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null;
    }
};

// chat conversation -> send chat conversation by id api
export const sendSuperAdminChatMessageAction = (dataToBeSent, setLoading) => async (dispatch) => {
  setLoading(true)
  const response = await requestFromServer.sendSuperAdminChatMessage(dataToBeSent);
  if (response) {
    setLoading(false)
      return response;
    }
    else {
      setLoading(false)
      return null;
    }
};
